import { environment } from '../../../environments/environment';
import { Component, OnInit , ViewChild} from '@angular/core';
import { NavigationService } from '../../services/navigation-service';
import { AuthenticationService } from '../../services/auth-service';
import { UserAvatarService } from '../../services/user-avatar-service';
import { ActividadService } from '../../services/actividad-service';
import { Router } from '@angular/router';
import { SignalrService } from '../../signalr/signalR.service';
import { PreciosService } from '../../services/precios-service';
import { SpinnerService } from '../../services/spinner-service';
import {PermisosService} from '@services/permisos-service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {

  private username: string
  private password: string
  ASSETS_URL = environment.ASSETS_URL;

  public loginError: boolean = false;
  public logginIn: boolean = false;

  constructor(private navigationService: NavigationService,
              private authService: AuthenticationService,
              private avatarService: UserAvatarService,
              private actividadService: ActividadService,
              private router: Router,
              private signalRService: SignalrService,
              private preciosService: PreciosService,
              private spinnerService: SpinnerService,
              private permisosService: PermisosService,
  ) {}

  ngOnInit() {
    this.spinnerService.setShowFlag(false);
  }

  login() {
    this.loginError = false;
    this.logginIn = true;
    this.authService.login(this.username, this.password).subscribe(
      data => {
        // set the avatar in the nav menu
        this.avatarService.setAvatar(
          environment.IMAGES_URL + '/images/' + data.userId + '.png'
        );
        
        this.signalRService.isInitialized.subscribe(b => {
          if (b) {
            this.signalRService.startConnection();
          }
        });
        this.preciosService.setBubbleValues(false, 'pizarra');
        this.preciosService.setBubbleValues(false, 'precio');
        this.actividadService.checkNewActivities();
        this.preciosService.checkNewPricesForReview();

        this.router.navigateByUrl('/');
      },
      error => {
        this.loginError = true;
        this.logginIn = false;
      }
    );
  }

  toggleNav() {
    this.navigationService.toggleNav(true);
  }
}



// WEBPACK FOOTER //
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/components/login/login.component.ts